import { render, staticRenderFns } from "./ImpresionCanje2.vue?vue&type=template&id=4fbf2a3a&scoped=true&"
import script from "./ImpresionCanje2.vue?vue&type=script&lang=js&"
export * from "./ImpresionCanje2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf2a3a",
  null
  
)

export default component.exports